export default {
  computed: {
    vModel: {
      get(){
        return this.value
      },
      set(data){
        this.$emit('input', data)
      }
    }
  },
  props: {
    value: null
  }
}


// WEBPACK FOOTER //
// ./src/utils/mixins/vModel.js